import React from "react";
import ChannelCard from "../../Utilities/ChannelCard";
import logoShopify from "../../../../../images/logos/logo_shopify.svg";
import useShopifySetup from "./useShopifySetup";

export default function ShopifyProvider(){
    const { initiateShopifySetup } = useShopifySetup();

    return(
        <ChannelCard
            icon={logoShopify}
            label={'Shopify'}
            description={'Connect your Shopify store to track conversions'}
            onClick={initiateShopifySetup}
        />
    )
}